import React, {Component} from 'react';

import styled from 'styled-components';

import ErrorMessage from '../../../components/common/ErrorMessage';
import { Mutation } from 'react-apollo';
import BusyWrapper from '../../../components/common/BusyWrapper';
import gql from 'graphql-tag';
import { Controls, Header, Title } from '../../../components/styles/ListStyles';
import { Link, withRouter } from 'react-router-dom';
import PrivatePage from '../../layouts/PrivatePage';

const Container = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const ADD_USER_MUTATION = gql`
    mutation ADD_USER_MUTATION($data: UserCreateInput!){
        createUser(
            data: $data
        ){
            id
        }
    }
`;

class AddUser extends Component {
  state = {
    name: '',
    email: '',
    password: ''
  };

  handleChange = (ev) => {
    this.setState({[ev.target.name]: ev.target.value});
  };

  async onSubmit(e, addUser){
    e.preventDefault();
    await addUser();
    this.props.history.push('/users');
  };

  render() {
    return (
      <PrivatePage permission="ADMIN">
        <Container>
          <Title>New user form</Title>
          <Mutation mutation={ADD_USER_MUTATION} variables={{data: this.state}} refetchQueries={['ALL_USERS_LIST']}>
            {(addUser, {loading, error}) => (
              <form onSubmit={ev => this.onSubmit(ev, addUser)}>
                <ErrorMessage error={error} />
                <BusyWrapper busy={loading}>
                  <fieldset>
                    <label>
                      Name
                      <input type='text' value={this.state.name} onChange={this.handleChange} name='name' />
                    </label>
                    <label>
                      Email
                      <input type='text' value={this.state.email} onChange={this.handleChange} name='email' />
                    </label>
                    <label>
                      Password
                      <input type='password' value={this.state.password} onChange={this.handleChange} name='password' />
                    </label>
                    <input type="submit" value="Create" className="button" />
                  </fieldset>
                </BusyWrapper>
              </form>
            )}
          </Mutation>
          <Link to='/users'>go back</Link>
        </Container>
      </PrivatePage>
    );
  }
}

export default withRouter(AddUser);
